import { createSelector } from '@reduxjs/toolkit'
import type { ScanState } from './scan.slice'

// Assuming the root state structure. 
// Note: You might need to adjust this depending on how the reducer is mounted.
// In Kiosk portal, we will mount it as 'scan' or 'shipments.scan'.
// For now, let's assume it's mounted under 'shipmentsScan' or we pass the local state.

// Helper to find the state slice
const selectScanState = (state: any): ScanState => {
  // Try different mounting points
  if (state.scan) return state.scan
  if (state.shipments?.scan) return state.shipments.scan
  if (state.shipmentsScan) return state.shipmentsScan
  
  // Fallback for when we might be testing or using a different mount
  return state
}

export const selectScannedOrder = createSelector(
  selectScanState,
  (state) => state.scannedOrder
)

export const selectScanSuggestions = createSelector(
  selectScanState,
  (state) => state.suggestions
)

export const selectIsScanning = createSelector(
  selectScanState,
  (state) => state.isScanning
)

export const selectIsSuggesting = createSelector(
  selectScanState,
  (state) => state.isSuggesting
)

export const selectIsAssigningResource = createSelector(
  selectScanState,
  (state) => state.isAssigningResource
)

export const selectScanError = createSelector(
  selectScanState,
  (state) => state.error
)

export const selectScanSuccess = createSelector(
  selectScanState,
  (state) => state.scanSuccess
)
